import {
    MONEY_FAIL,
    MONEY_SUCCESS, OGG_FAIL, OGG_SUCCESS, PRICE_FAIL, PRICE_SUCCESS,
    URS_FAIL,
    URS_REQUEST,
    URS_SUCCESS,
    USER_CRM_SUCCESS, USER_IN_BLOCK_SUCCESS,
    USERS_FAIL,
    USERS_REQUEST,
    USERS_SUCCESS,
    PROFILE_EMPLOYEE_SUCCESS,
    PROFILE_EMPLOYEE_REQUEST,
    PROFILE_EMPLOYEE_FAIL,
    EMPLOYEE_ISWEB_SET,
    LOGOUT_ADMIN,
    UNREAD_CHANNELS_SET,
    UNREAD_COUNTS_SET,
} from '../actions/users';


const initialState = {
    userStatus: 'request',
    userData: {},
    crmData: [],
    countData: {},
    ursData: {},
    fetchedPrice: false,
    prices: [],
    ogg: [],
    fetchedAdmin: false,
    fetchedMoney: false,
    counter: 0,
    fetchedOGG: false,
    money: [],
    employeeData: {},
    fetchedEmployee: false,
    unreadWhatsappEnabled: false,
    unreadTelegramEnabled: false,
    unreadTelegramMainId: null,
    whatsappUnread: 0,
    telegramUnread: 0,
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case USERS_REQUEST: {
            return {
                ...state,
                userStatus: 'request',
            };
        }
        case USERS_SUCCESS: {
            return {
                ...state,
                userStatus: 'success',
                userData: {...action.payload.data.user,clientIp:action.payload.data.clientIp},
                countData: action.payload.data.count,
            };
        }
        case USER_CRM_SUCCESS: {
            return {
                ...state,
                crmData:action.payload.data.crm
            };
        }
        case USERS_FAIL: {
            return {
                ...state,
                userStatus: 'fail',
                userData: action.payload.data,
                fetched:false,
            };
        }
        case USER_IN_BLOCK_SUCCESS: {
            return {
                ...state,
                counter: action.payload.data.members,
            };
        }
        case URS_REQUEST: {
            return {
                ...state,
                userStatus: 'request',
            };
        }
        case URS_SUCCESS: {
            return {
                ...state,
                userStatus: 'success',
                ursData: action.payload.data.user,
                fetchedAdmin:true
            };
        }
        case URS_FAIL: {
            return {
                ...state,
                userStatus: 'fail',
                ursData: action.payload.data,
                fetchedAdmin:false
            };
        }
        case MONEY_SUCCESS: {
            return {
                ...state,
                money: action.payload.data,
                fetchedMoney:true
            };
        }
        case MONEY_FAIL: {
            return {
                ...state,
                fetchedMoney:false
            };
        }
        case PRICE_SUCCESS: {
            return {
                ...state,
                prices: action.payload.data.data,
                fetchedPrice:true
            };
        }
        case PRICE_FAIL: {
            return {
                ...state,
                fetchedPrice:false
            };
        }

        case OGG_SUCCESS: {
            return {
                ...state,
                ogg: Object.values(action.payload.data.rows[0]),
                fetchedOGG:true
            };
        }
        case OGG_FAIL: {
            return {
                ...state,
                fetchedOGG:false
            };
        }

        case PROFILE_EMPLOYEE_SUCCESS: {
            const telegrams = Array.isArray(action.payload.data.telegrams) ? action.payload.data.telegrams : [];
            const waFromApi = action.payload.data.whatsapps ?? action.payload.data.whatsapp;
            const whatsapps = Array.isArray(waFromApi) ? waFromApi : [];
            const telegramMainId = telegrams.length > 0
                ? Number(telegrams[0]?.id || telegrams[0]?.ID || 0) || null
                : null;
            return {
                ...state,
                userData: {...action.payload.data.member},
                employeeData: {
                    ...action.payload.data.user,
                    telegrams,
                    whatsapps,
                },
                fetchedEmployee: true,
                countData: action.payload.data.count,
                unreadWhatsappEnabled: whatsapps.length > 0,
                unreadTelegramEnabled: telegrams.length > 0,
                unreadTelegramMainId: telegramMainId,
            };
        }
        case LOGOUT_ADMIN: {
            return {
                ...state,
                userData: {},
                employeeData: {},
                fetchedEmployee: false,
                unreadWhatsappEnabled: false,
                unreadTelegramEnabled: false,
                unreadTelegramMainId: null,
                whatsappUnread: 0,
                telegramUnread: 0,
            };
        }
        case UNREAD_CHANNELS_SET: {
            return {
                ...state,
                unreadWhatsappEnabled: !!action.payload.whatsappEnabled,
                unreadTelegramEnabled: !!action.payload.telegramEnabled,
                unreadTelegramMainId: action.payload.telegramMainId != null ? Number(action.payload.telegramMainId) : null,
            };
        }
        case UNREAD_COUNTS_SET: {
            return {
                ...state,
                whatsappUnread: Number(action.payload.whatsappUnread || 0),
                telegramUnread: Number(action.payload.telegramUnread || 0),
            };
        }
        case PROFILE_EMPLOYEE_FAIL: {
            return {
                ...state,
                fetchedEmployee: false,
                unreadWhatsappEnabled: false,
                unreadTelegramEnabled: false,
                unreadTelegramMainId: null,
                whatsappUnread: 0,
                telegramUnread: 0,
            };
        }
        case EMPLOYEE_ISWEB_SET: {
            return {
                ...state,
                employeeData: {
                    ...state.employeeData,
                    isweb: action.payload.isweb,
                },
            };
        }
        case PROFILE_EMPLOYEE_REQUEST: {
            return {
                ...state,
            };
        }
        default: {
            return {
                ...state,
            };
        }
    }
}
